import React from "react";

const ReglesCalculSearch = ({
  value,
  onChange,
  champsCount,
  reglesCount,
}) => {
  return (
    <div className="regles-calcul__search">
      <div className="regles-calcul__search-input-wrapper">
        <i className="fas fa-search regles-calcul__search-icon" />
        <input
          type="text"
          className="form-control regles-calcul__search-input"
          placeholder="Rechercher un champ, une formule, un prérequis…"
          value={value}
          onChange={(e) => onChange(e.target.value)}
        />
        {value && (
          <button
            type="button"
            className="regles-calcul__search-clear"
            onClick={() => onChange("")}
            aria-label="Effacer la recherche"
          >
            <i className="fas fa-times" />
          </button>
        )}
      </div>
      <div className="regles-calcul__search-counter">
        {champsCount} champ{champsCount > 1 ? "s" : ""} · {reglesCount} règle
        {reglesCount > 1 ? "s" : ""}
      </div>
    </div>
  );
};

export default ReglesCalculSearch;
